/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector, defaultMemoize } from 'reselect';
import { getABtestFromState, parseBoolean } from '@tcp/core/src/utils';
import { fromJS } from 'immutable';
import {
  getIsBopisEnabled,
  getIsPersistPointsApiEnabled,
  getIsAddedToBagRedesignEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { getCartOrderDetails } from '../../CartItemTile/container/CartItemTile.selectors';
import { getSelectedAccessories } from '../../../../common/molecules/Accessories/container/Accessories.selectors';

export const getCheckoutLoaderState = (state) => {
  return state.PageLoader && state.PageLoader.checkoutLoader;
};

export const getAddedToBagLoaderState = (state) => {
  return state.PageLoader && state.PageLoader.addedToBagLoaderState;
};

export const getLoyaltyAPICallStatus = (state) => {
  return state.PageLoader && state.PageLoader.loyaltyAPICallStatus;
};

export const getATbAPICallStatus = (state) => {
  return state.PageLoader && state.PageLoader.aTbAPICallStatus;
};

export const getATBMaintenanceStatus = (state) => {
  return state.PageLoader && state.PageLoader.aTBMaintenanceState;
};

export const getAddedToBagGhostLoaderState = (state) => {
  return state.PageLoader && state.PageLoader.addedToBagGhostLoaderState;
};

export const getAddedToBagGhostLoaderCompleteState = (state) => {
  return state.PageLoader && state.PageLoader.addedToBagGhostLoaderCompleteState;
};

const addedToBag = (state) => state?.AddedToBagReducer;

export const addedToBagMsgSelector = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('addedTobagMsg');
};
export const loyaltyAbTestFlagSelector = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('loyaltyAbTestFlag');
};

export const getMultipackProductType = defaultMemoize((state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('multipackProductType');
});

export const getIsMpackItem = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('isMpackItem');
};

export const getBagAnalyticsData = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('cartAnalyticsData');
};

export const getEnableKeepShoppingCTA = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return parseBoolean(getAbtests.enableKeepShoppingCTA);
};

export const getShowBOPISPickupInstead = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return parseBoolean(getAbtests.showBOPISPickupInstead);
};

export const getEnableBOPISPickupInstead = createSelector(
  [getIsBopisEnabled, getShowBOPISPickupInstead],
  (isBopisEnabled, showBOPISPickupInstead) => isBopisEnabled && showBOPISPickupInstead
);

export const getPageType = (state) => {
  return state.pageData && state.pageData.pageType;
};

const itemInfoFunc = defaultMemoize(
  (state) => state.AddedToBagReducer && state.AddedToBagReducer?.get('itemInfo')
);

const getOrderItemsCart = createSelector(getCartOrderDetails, (orderDetails) => {
  const items = [];
  if (orderDetails.size > 0) return orderDetails.get('orderItems');
  return items;
});
const addAccessoriesData = (data, selectedAccessories) => {
  if (selectedAccessories && selectedAccessories.length > 0) {
    // eslint-disable-next-line prefer-const
    let productWithAccessories = [];
    productWithAccessories.push(data);
    const { accessories = [] } = data;

    for (let i = 0; i < accessories.length; i += 1) {
      if (accessories[i]?.skuInfo?.TCPStyleType !== '0007')
        productWithAccessories.push(accessories[i]);
    }
    return productWithAccessories;
  }
  return data;
};

export const getAddedToBagData = createSelector(
  getOrderItemsCart,
  itemInfoFunc,
  getSelectedAccessories,
  // will be fixed in upcoming PR's
  // eslint-disable-next-line sonarjs/cognitive-complexity
  (orderItems, itemInfo, accessories) => {
    let data = itemInfo && itemInfo.productItemsInfo ? itemInfo.productItemsInfo : itemInfo;
    data = addAccessoriesData(data, accessories);
    if (itemInfo && data.length > 0) {
      data = data.map((item) => {
        const itemCopy = Object.assign({}, item);
        if (orderItems) {
          orderItems.forEach((orderItem) => {
            if (item?.orderItemId === orderItem.getIn(['itemInfo', 'itemId'])) {
              itemCopy.listPrice = orderItem.getIn(['itemInfo', 'listPrice']);
              itemCopy.itemPoints = orderItem.getIn(['itemInfo', 'itemPoints']);
              itemCopy.itemPrice = orderItem.getIn(['itemInfo', 'listPrice']);
              itemCopy.quantity = orderItem.getIn(['itemInfo', 'quantity']);
              itemCopy.brand = orderItem.getIn(['productInfo', 'itemBrand']);
              if (itemInfo?.isFromPjPlanner) {
                itemCopy.isFromPjPlanner = true;
              }
            } else if (
              item?.skuInfo?.variantId === orderItem.getIn(['productInfo', 'generalProductId'])
            ) {
              itemCopy.itemPoints = orderItem.getIn(['itemInfo', 'itemPoints']);
            }
          });
        }
        return itemCopy;
      });
    }
    if (orderItems) {
      orderItems.forEach((orderItem) => {
        if (data?.orderItemId === orderItem.getIn(['itemInfo', 'itemId'], '')) {
          data.brand = orderItem.getIn(['productInfo', 'itemBrand'], '');
        }
      });
      return data;
    }
    return data;
  }
);

export const isPlccICFired = (state) =>
  state.AddedToBagReducer && state.AddedToBagReducer?.get('isPlccICFired');

export const isOpenAddedToBag = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('isOpenAddedToBag');
};

export const isOpenAddedToBagMinimal = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('isOpenAddedToBag');
};

export const getPayloadData = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('payloadData');
};

export const getOrderItems = (state) => {
  return getCartOrderDetails(state) && getCartOrderDetails(state).get('orderItems');
};

export const getAddedToBagError = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('error');
};

export const getAddedToBagPayloadItemCount = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('addToBagTotalItemCount');
};

export const getAddedToBagFbtError = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('fbtError');
};

export const getAddedToBagModalError = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('modalError');
};

export const getMultipleItemsAddedToBagError = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('multipleItemsError');
};

export const getMultipleOutfitsItemsError = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('multipleOutfitsItemsError');
};

export const getAdddToBagBtnLoader = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('addedToBagBtnLoader');
};

export const getAddedToPickupError = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('pickupError');
};

export const filterItemObject = (arr, searchedValue) => {
  const filteredValue = arr.filter((value) => {
    return (
      value.getIn(['itemInfo', 'itemId']) &&
      searchedValue?.orderItemId &&
      value.getIn(['itemInfo', 'itemId']).toString() === searchedValue?.orderItemId.toString()
    );
  });
  return filteredValue.get(0);
};

export const getFilteredValue = (value, lastItem) => {
  if (getIsAddedToBagRedesignEnabled) {
    return value.getIn(['itemInfo', 'itemId']);
  }
  return (
    value.getIn(['itemInfo', 'itemId']) &&
    lastItem?.orderItemId &&
    value.getIn(['itemInfo', 'itemId']).toString() === lastItem?.orderItemId.toString()
  );
};

export const filterItemObjectFromArray = (arr, searchedValue) => {
  const filteredData = [];
  let lastItemsData;
  if (typeof arr !== 'undefined') {
    lastItemsData = searchedValue.map((lastItem) => {
      const filteredValue = arr.filter((value) => getFilteredValue(value, lastItem));
      const filteredValueParam = filteredValue.get(0);
      filteredData.push({
        itemPrice: filteredValueParam ? filteredValueParam.getIn(['itemInfo', 'offerPrice']) : 0,
        itemPoints: filteredValueParam ? filteredValueParam.getIn(['itemInfo', 'itemPoints']) : 0,
        quantity: filteredValueParam ? filteredValueParam.getIn(['itemInfo', 'quantity']) : 0,
      });
      return filteredData;
    });
    return {
      filteredPrice: lastItemsData[0].reduce((a, b) => a + (b.itemPrice || 0), 0),
      filteredProductItemPoints: lastItemsData[0].reduce((a, b) => a + (b.itemPoints || 0), 0),
      filteredProductQuantity: lastItemsData[0].reduce((a, b) => a + (b.quantity || 0), 0),
    };
  }
  return {};
};

export const getQuantityValue = (state) => {
  let quantity = '';
  const orderItems = getOrderItems(state);
  const lastAddedToBag = getAddedToBagData(state);
  if (orderItems && lastAddedToBag) {
    const lastAddedItem = filterItemObject(orderItems, lastAddedToBag);
    quantity = lastAddedItem && lastAddedItem.getIn(['itemInfo', 'quantity']);
  }
  if (lastAddedToBag && lastAddedToBag.length) {
    const hasAccessory = lastAddedToBag[0]?.accessories?.length;
    if (hasAccessory) {
      quantity = state.AddedToBagReducer.getIn(['itemInfo', 'quantity']) || 1;
    }
  }
  return quantity;
};

export const getATBItemInfo = (state) => {
  return state.AddedToBagReducer?.get('itemInfo');
};

export const getPrice = (state) => {
  let price = '';
  const orderItems = getOrderItems(state);
  const lastAddedToBag = getAddedToBagData(state);
  if (orderItems && lastAddedToBag) {
    const lastAddedItem = filterItemObject(orderItems, lastAddedToBag);
    price = lastAddedItem && lastAddedItem.getIn(['itemInfo', 'listPrice']);
  }
  return price;
};

const getOrderItemsDetails = (state) => {
  return state.get('orderItems');
};

const getOrderItemsData = (getOrderPointsSummary, lastAddedToBag) => {
  // Determine where to pick orderItems data AddedtoBag State or orderDetails State
  return getOrderItemsDetails(getOrderPointsSummary) &&
    ((lastAddedToBag.estimatedRewards === -1 &&
      lastAddedToBag.pointsApi &&
      lastAddedToBag.pointsApi !== 'NA') ||
      !lastAddedToBag.estimatedRewards)
    ? getOrderItemsDetails(getOrderPointsSummary)
    : fromJS(lastAddedToBag.orderItems);
};

const createPointSummaryObj = ({
  obj,
  productItemPoints,
  lastAddedItem,
  offerPrice,
  pointsApi,
}) => {
  let pointsSummary = {};
  if (lastAddedItem && offerPrice > 0) {
    pointsSummary = {
      itemPrice: offerPrice,
      itemPoints: productItemPoints,
      pointsToNextReward: obj.pointsToNextReward,
      userPoints: obj.estimatedRewards || 0,
      bagSubTotal:
        (obj.productTotal || 0) - (obj.giftWrappingTotal || 0) ||
        (obj.grandTotal || 0) - (obj.giftCardsTotal || 0),
      totalItems: obj.totalItems || 0,
      isBrierleyWorking: obj.isBrierleyWorking,
      cartTotalAfterPLCCDiscount: obj.cartTotalAfterPLCCDiscount,
      earnedReward: obj.earnedReward,
      orderSubTotalDiscount: obj.orderSubTotalDiscount,
      pointsApi,
    };
  }
  return pointsSummary;
};

export const getAddedToBagInterval = (state) => {
  return parseInt(state.session.siteDetails.ADDED_TO_BAG_MODAL_INTERVAL, 10) || 0;
};

const getUpdateCartFlag = (state) =>
  defaultMemoize(state.CartPageReducer.getIn(['uiFlags', 'updateCartComplete'], false));

export const getPointsSummary = createSelector(
  getCartOrderDetails,
  getAddedToBagData,
  getUpdateCartFlag,
  getIsPersistPointsApiEnabled,
  (getOrderPointsSummary, lastAddedToBag, updateCartFlag, isLoyaltyPointsEnabled) => {
    const emptyObj = {};
    if (!updateCartFlag) return emptyObj;
    const ifmultipleAddedItems = Array.isArray(lastAddedToBag);
    let orderItems;
    if (ifmultipleAddedItems) {
      orderItems = getOrderItemsDetails(getOrderPointsSummary);
    } else {
      orderItems = getOrderItemsData(getOrderPointsSummary, lastAddedToBag);
    }
    let pointsSummary = {};
    let lastAddedItem;
    let offerPrice;
    let productItemPoints;

    if (orderItems) {
      if (ifmultipleAddedItems) {
        lastAddedItem = filterItemObjectFromArray(orderItems, lastAddedToBag);
        const { filteredPrice, filteredProductItemPoints } = lastAddedItem;
        offerPrice = filteredPrice;
        productItemPoints = filteredProductItemPoints;
      } else {
        lastAddedItem = filterItemObject(orderItems, lastAddedToBag);
        offerPrice = lastAddedItem && lastAddedItem.getIn(['itemInfo', 'offerPrice']);
        productItemPoints = lastAddedItem && lastAddedItem.getIn(['itemInfo', 'itemPoints']);
      }

      const obj = {
        totalItems: getOrderPointsSummary.get('totalItems'),
        grandTotal: getOrderPointsSummary.get('grandTotal'),
        giftCardsTotal: getOrderPointsSummary.get('giftCardsTotal'),
        isBrierleyWorking: getOrderPointsSummary.get('isBrierleyWorking'),
        cartTotalAfterPLCCDiscount: getOrderPointsSummary.get('cartTotalAfterPLCCDiscount'),
        earnedReward: getOrderPointsSummary.get('earnedReward'),
        orderSubTotalDiscount: getOrderPointsSummary.get('orderSubTotalDiscount'),
        pointsToNextReward: getOrderPointsSummary.get('pointsToNextReward'),
        estimatedRewards: getOrderPointsSummary.get('estimatedRewards'),
        productTotal: getOrderPointsSummary.get('productTotal'),
        giftWrappingTotal: getOrderPointsSummary.get('giftWrappingTotal'),
        giftDiscountTotal: getOrderPointsSummary.get('giftDiscountTotal'),
        pointsToRedeem: getOrderPointsSummary.get('pointsToRedeem'),
      };
      let { pointsApi } = lastAddedToBag;

      if (!isLoyaltyPointsEnabled) {
        pointsApi = 'NA';
      }
      pointsSummary = createPointSummaryObj({
        obj,
        productItemPoints,
        lastAddedItem,
        offerPrice,
        pointsApi,
      });
    }
    return pointsSummary;
  }
);

export const getGrandTotal = (state) => {
  const orderItems = getCartOrderDetails(state);
  return orderItems && orderItems.get('grandTotal') ? orderItems.get('grandTotal').toFixed(2) : 0;
};

export const getStickyATBState = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('stickyFooter');
};
export const getPDPlargeImageColorSelector = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('pdpLargeImageUrlOnHover');
};

export const getPointsToNextReward = (state) => {
  return (
    (state.AddedToBagReducer &&
      state.AddedToBagReducer?.getIn(['itemInfo', 'pointsToNextReward'])) ||
    0
  );
};

export const getLowInventoryMonetateExp = (state) => {
  return (
    (state.AddedToBagReducer &&
      state.AddedToBagReducer?.getIn(['itemInfo', 'displayLowInvMonetateExp'])) ||
    false
  );
};

export const getFbtDisplayedState = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('isFbtDisplayed');
};

export const getAddToBagInProgress = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('isAddToBagInProgress');
};

export const getShowSizeSelectMsg = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('showSelectSizeMsg');
};

export const getIsFbtCompletedState = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('isFbtCompleted');
};

export const getIsFbtEnabledState = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('isFbtEnabled');
};

export const getIsKeepMinibagClose = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('keepMinibagClose');
};

export const getLoyaltyPointsRequestPayload = (state) => {
  return (
    state.AddedToBagReducer && state.AddedToBagReducer?.getIn(['itemInfo', 'loyaltyOrderItems'])
  );
};

export const getGrandPoint = (state) => {
  const orderItems = getCartOrderDetails(state);
  return orderItems && orderItems.get('estimatedRewards');
};

export const getEarnedReward = (state) => {
  const orderItems = getCartOrderDetails(state);
  return orderItems && orderItems.get('earnedReward');
};

export const getAddedToBagMethod = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('addedToBagMethod');
};

export const getAddedToBagPagination = (state) => {
  return state.AddedToBagReducer && state.AddedToBagReducer?.get('addedToBagPagination');
};

export const getLastAddedProductId = (state) => {
  return (
    state.AddedToBagReducer && state.AddedToBagReducer?.getIn(['itemInfo', 'skuInfo', 'productId'])
  );
};

export const getOfferPriceIsLoading = createSelector(addedToBag, (addedToBagState) => {
  return addedToBagState.get('offerPriceIsLoading');
});

export const getATBUnavailableProducts = createSelector(addedToBag, (addedToBagState) => {
  return addedToBagState?.get('atbUnavailableProductIds');
});

export const getIsInventoryUnavailable = createSelector(addedToBag, (addedToBagState) => {
  return addedToBagState?.get('setInventoryUnavailable');
});
